import React, { useState, Fragment, useEffect, useMemo } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import styled from '@emotion/styled';
import { connect } from 'react-redux';
import { BsMicFill } from 'react-icons/bs';
import { HiOutlineLightBulb } from 'react-icons/hi';
import { VscLoading } from 'react-icons/vsc';
import { toast } from 'react-toastify';

import { fetchWrapper, getFormDataWithValue } from '@/_helpers';
import AudioRecorder from '@/lib/AudioRecorder';
import { uploadTranscriptAudioFile } from '@/_redux';
import {
    RecordButton,
    RecordButtonContainer,
    RecordFloatingContainer,
    RecordingTips,
} from './styles/FormFillWithAudio.styles';
import { Container, PartialTextPreviewBox } from '../../Record/Audio/styles/TranscribeStreamingStyle';

const ModalContainer = styled.div`
    box-shadow: rgba(0, 0, 0, 0.56) 0px 22px 70px 4px;
    padding: 16px 0;
    border: 10px solid #ccc;
`;

const Step = {
    IDLE: 'IDLE',
    RECORDING: 'RECORDING',
    TRANSCRIBING: 'TRANSCRIBING',
    PREVIEW: 'PREVIEW',
    APPLYING: 'APPLYING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};

const FormFillWithAudio = ({
    currUser,
    label,
    roomId,
    formId,
    isBusy,
    setUserFormData,
    setFormData,
    userFormData,
    form,
    position,
    setIsFetchingUserFormData,
    formSubmissionData,
}) => {
    const [show, setShow] = useState(false);
    const [step, setStep] = useState(Step.IDLE);
    const [error, setError] = useState('');
    const [transcript, setTranscript] = useState('');
    const _chatroomId = useMemo(() => roomId || userFormData?.chatroom || form?.chatroom, [roomId, form, userFormData]);
    const _formId = useMemo(() => form?._id || formId, [formId, form]);

    const handleShow = () => {
        if (isBusy) return;
        setTranscript('');
        setStep(Step.IDLE);
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
        setStep(Step.IDLE);
        setTranscript('');
    };

    const handleRecordingComplete = async (blob) => {
        setShow(true);
        setStep(Step.TRANSCRIBING);
        try {
            const formData = new FormData();
            if (blob) formData.append('file', blob);
            const body = {
                chatroom: _chatroomId,
                form: _formId,
            };
            if (position && position?.coords) {
                body.location = JSON.stringify({ lat: position.coords.latitude, lng: position.coords.longitude });
            }
            if (userFormData && userFormData?._id) {
                body.userformdata = userFormData?._id;
            }

            const response = await uploadTranscriptAudioFile(formData, body);

            if (response) {
                setTranscript((prev) => prev + ' ' + response?.transcript || '');
                setStep(Step.PREVIEW);
            }
            setUserFormData(response?.userformdata || {});
            return response?.userformdata?._id;
        } catch (err) {
            toast.error('Transcription failed.');
            console.error(err);
            setStep(Step.ERROR);
        }
    };

    const handleApplyTranscription = async () => {
        setStep(Step.APPLYING);
        try {
            let userformdata = userFormData?._id;
            if (!userformdata) {
                userformdata = await handleRecordingComplete();
            }

            setIsFetchingUserFormData(true);
            const body = {
                chatroom: roomId || _chatroomId,
                form: _formId,
                text: transcript,
                userformdata,
            };
            if (formSubmissionData?.seenFields && formSubmissionData?.seenFields?.length) {
                body.seenFields = formSubmissionData?.seenFields;
            }
            if (position && position?.coords) {
                body.location = JSON.stringify({ lat: position.coords.latitude, lng: position.coords.longitude });
            }

            const response = await fetchWrapper.post('forms/integrations/fill-form', body);
            const updatedUserFormData = response?.userFormData || {};
            const updatedFormElements = getFormDataWithValue([...(form?.data || [])], updatedUserFormData?.data || []);
            setFormData((_prev) => ({
                ...(_prev || form || {}),
                data: updatedFormElements,
            }));
            setUserFormData(updatedUserFormData);
            setStep(Step.SUCCESS);
            toast.success(response?.message);
            handleClose();
        } catch (e) {
            toast.error(e?.message);
            console.error(e);
            setStep(Step.ERROR);
        } finally {
            setIsFetchingUserFormData(false);
            setStep(Step.IDLE);
        }
    };

    const handleClearTranscription = () => {
        setTranscript('');
        setStep(Step.IDLE);
    };

    useEffect(() => {
        if (show) {
            setError('');
            const formType = form?.formType;
            const isLocationOptional = form?.isLocationOptional;
            if ((formType === 'eos' || formType === 'sos' || !isLocationOptional) && (!position || !position?.coords)) {
                setError('User Location is required! Please turn on location and refresh.');
            }
        }
        console.log('form', form);
    }, [show, form]);

    if (!currUser?._id) return null;

    return (
        <Fragment>
            {/* <RecordButtonContainer> */}
            {/* <RecordButton isProcessing={isBusy}> */}
            <RecordFloatingContainer>
                {show && (step === Step.APPLYING || step === Step.TRANSCRIBING) && (
                    <VscLoading className="spin" size={50} />
                )}
                {(step === Step.IDLE || step === Step.PREVIEW || step === Step.ERROR) && (
                    <>
                        {error && <Alert variant="danger">{error}</Alert>}

                        <div className="d-flex flex-row  border border-1 p-3 " style={{ borderRadius: '10px' }}>
                            {step !== Step.ERROR && (
                                <AudioRecorder
                                    onRecordingComplete={handleRecordingComplete}
                                    onRecordingStart={() => {
                                        // setShow(true);
                                        // setStep(Step.RECORDING)
                                    }}
                                    onRecordingStop={() => setStep(Step.TRANSCRIBING)}
                                    maxDuration={300}
                                    fileName="userformdata-transcript.mp4"
                                    compact
                                />
                            )}
                        </div>
                    </>
                )}
                {/* <div className="mt-4">
                        <p className="">
                            {' '}
                            <HiOutlineLightBulb color="orange" size={20} className="mb-2 mr-1" />
                            Speak clearly and include field names followed by values
                        </p>
                        <p className="ml-4">Example: "Name: John Doe, Address: 123 Main Street"</p>
                    </div> */}
                {/* </RecordButton> */}
            </RecordFloatingContainer>
            {/* 
                <RecordingTips>
                    <p>
                        <HiOutlineLightBulb color="orange" size={20} className="mb-2" />
                        <span className="mt-2">Recording Tips:</span>
                    </p>
                    <p>Speak clearly and include field names followed by values</p>
                    <p>Example: "Name: John Doe, Address: 123 Main Street"</p>
                </RecordingTips> */}
            {/* </RecordButtonContainer> */}
            <Modal show={show} onHide={handleClose} size="lg" centered aria-labelledby="contained-modal-title-vcenter">
                <ModalContainer>
                    <Modal.Header className="d-flex justify-content-center">
                        <RecordingTips>
                            <p>
                                <HiOutlineLightBulb color="orange" size={20} className="mb-2" />
                                <span className="mt-2">Recording Tips:</span>
                            </p>
                            <p>Speak clearly and include field names followed by values</p>
                            <p>Example: "Name: John Doe, Address: 123 Main Street"</p>
                        </RecordingTips>
                    </Modal.Header>

                    <Modal.Body
                        style={{
                            maxHeight: 'calc(100vh - 160px)',
                            padding: '0 48px 0',
                            overflowY: 'scroll',
                            overflowX: 'hidden',
                            minHeight: '200px',
                        }}
                    >
                        <Container>
                            <h2>{label}</h2>

                            {step === Step.TRANSCRIBING && (
                                <div className="text-center my-3">
                                    <VscLoading className="spin" size={28} />
                                    <p>Transcribing audio...</p>
                                </div>
                            )}

                            {step === Step.RECORDING && (
                                <div className="text-center my-3">
                                    <p>Recording in progress...</p>
                                </div>
                            )}
                            {step === Step.APPLYING && (
                                <div className="text-center my-3">
                                    <VscLoading className="spin" size={28} />
                                    <p>Preparing and filling form data...</p>
                                </div>
                            )}
                            {(step === Step.IDLE || step === Step.PREVIEW || step === Step.ERROR) && (
                                <>
                                    <PartialTextPreviewBox
                                        height="500px"
                                        value={transcript}
                                        onChange={(e) => setTranscript(e.target.value)}
                                    />

                                    {error && <Alert variant="danger">{error}</Alert>}

                                    <div className="d-flex flex-row mt-4">
                                        {/* {step !== Step.ERROR && (
                                            <AudioRecorder
                                                onRecordingComplete={handleRecordingComplete}
                                                onRecordingStart={() => setStep(Step.RECORDING)}
                                                onRecordingStop={() => setStep(Step.TRANSCRIBING)}
                                                maxDuration={300}
                                                fileName="userformdata-transcript.mp4"
                                                compact
                                            />
                                        )} */}
                                        <div className="ml-4">
                                            <Button
                                                onClick={handleApplyTranscription}
                                                disabled={!transcript || step === Step.APPLYING}
                                                className="ml-2"
                                            >
                                                {step === Step.APPLYING ? (
                                                    <>
                                                        <VscLoading className="spin" size={50} /> Applying...
                                                    </>
                                                ) : (
                                                    'Apply Transcription'
                                                )}
                                            </Button>
                                            <Button
                                                onClick={handleClearTranscription}
                                                className="ml-4"
                                                variant="secondary"
                                                disabled={step === Step.APPLYING}
                                            >
                                                Clear
                                            </Button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </Container>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose} disabled={step === Step.TRANSCRIBING}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </ModalContainer>
            </Modal>
        </Fragment>
    );
};

const mapStateToProps = (state) => ({
    teams: state.teams.teams,
    currUser: state.user.user,
    position: state.user.position,
    formSubmissionData: state.formSubmissionData,
});

export default connect(mapStateToProps, {})(FormFillWithAudio);
